export default ({ app, store }) => {
  app.$sentry.setUser({ username: store.state.user.user.name, email: store.state.user.user.email })
}
